import React, { useEffect, useState } from 'react';
import update from 'immutability-helper';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { MdMaximize, MdOutlineCloudDownload, MdOutlineContentCopy, MdVerticalAlignBottom, MdVerticalAlignTop } from 'react-icons/md';
import { toast } from 'react-toastify';

import { StorageEnum } from '../../utils/enumerators/Storage.enum';
import { getClientsServers } from '../../utils/services/gitlab-service';
import { getB2cDistributions, getServerStatus } from '../../utils/services/service';
import { formatDateToBrazilian, getTimeOfflineText } from '../../utils/utils';
import PageDefault from '../PageDefault/PageDefault';

import './Status.scss';

let interval;
function Status() {
	const refreshMinutesStorage = localStorage.getItem(StorageEnum.REFRESH_MINUTES);
	const headerExpanded = JSON.parse(localStorage.getItem(StorageEnum.HEADER_EXPANDED));

	const [clients, setClients] = useState([]);
	const [pesquisa, setPesquisa] = useState('');
	const [refreshMinutes, setRefreshMinutes] = useState(refreshMinutesStorage || 15);
	const [countdown, setCountdown] = useState(`Atualizará em ${refreshMinutes} minuto(s) e 0 segundo(s)...`);
	const [expanded, setExpanded] = useState(headerExpanded || false);
	const [awsState, setAwsState] = useState(true);

	let countdownDuration = 0;

	useEffect(async () => {
		getClientsServerStatus();
		startCountdown();
	}, []);

	useEffect(() => {
		startCountdown();

		localStorage.setItem(StorageEnum.REFRESH_MINUTES, refreshMinutes);
	}, [refreshMinutes]);

	useEffect(() => {
		localStorage.setItem(StorageEnum.HEADER_EXPANDED, expanded.toString());
	}, [expanded]);

	function startCountdown() {
		if (interval != null) {
			clearInterval(interval);
			countdownDuration = 0;
		}

		interval = setInterval(function () {
			if (document.location.pathname != '/status') {
				clearInterval(interval);
				return;
			}
			countdownDuration += 1000;

			var total = refreshMinutes * 60 * 1000;

			var minutes = Math.floor((total - countdownDuration) / 60000);
			var seconds = (((total - countdownDuration) % 60000) / 1000).toFixed(0);

			if (countdownDuration >= total) {
				setCountdown(`Atualizando...`);
				clearInterval(interval);
				location.reload();
			} else {
				setCountdown(`Atualizará em ${minutes} minuto(s) e ${seconds} segundo(s)...`);
			}
		}, 1000);
	}

	function getClientsServerStatus() {
		getB2cDistributions(
			(clients) => {
				setClients(clients);

				clients.forEach((client) => {
					getServerStatus(client.domain, (online) => {
						const clientElement = document.getElementById(`client-${client.domain}`);

						if (clientElement) {
							const statusElement = clientElement.querySelector('.status');

							if (statusElement) {
								client.status = online ? 'online' : 'offline';

								let timeOffline = null;

								let b2cOfflines = JSON.parse(localStorage.getItem(StorageEnum.B2C_OFFLINES));

								if (b2cOfflines == null) {
									b2cOfflines = [];
								}

								const clientOfflineIndex = b2cOfflines.findIndex((x) => x.domain == client.domain);

								if (clientOfflineIndex >= 0) {
									if (online) {
										b2cOfflines.splice(clientOfflineIndex, 1);
									} else {
										timeOffline = b2cOfflines[clientOfflineIndex].time;
									}
								} else if (!online && clientOfflineIndex < 0) {
									timeOffline = new Date().getTime();
									b2cOfflines.push({ domain: client.domain, time: timeOffline });
								}

								localStorage.setItem(StorageEnum.B2C_OFFLINES, JSON.stringify(b2cOfflines));

								client.timeOffline = timeOffline;

								if (timeOffline) {
									client.offlineText = getTimeOfflineText(timeOffline);
								}

								const index = clients.findIndex((emp) => emp.domain === client.domain);
								let updatedClients = update(clients, {
									$splice: [[index, 1, client]],
								});

								updatedClients.sort((a, b) => (a.timeOffline < b.timeOffline ? 1 : -1));

								updatedClients = updatedClients.sort(function (a, b) {
									if (a.status == null && b.status != null) {
										return -1;
									}
									if (a.status != null && b.status == null) {
										return 1;
									}

									return 0;
								});

								updatedClients = updatedClients.sort(function (a, b) {
									if (a.status == 'offline' && b.status == 'online') {
										return -1;
									}
									if (a.status == 'online' && b.status == 'offline') {
										return 1;
									}

									return 0;
								});

								setClients(updatedClients);
							}
						}
					});
				});
			},
			() => {
				setAwsState(false);
			},
		);
	}

	function filterClients(client) {
		return pesquisa == '' || client.domain.toUpperCase().includes(pesquisa.toUpperCase()) || client.comment.toUpperCase().includes(pesquisa.toUpperCase());
	}

	function sync() {
		localStorage.removeItem(StorageEnum.B2C_DISTRIBUTIONS);

		setCountdown(`Atualizando...`);
		clearInterval(interval);
		location.reload();
	}

	return (
		<PageDefault showFooter={!expanded}>
			<div className="status">
				<div className={`header ${expanded ? 'expanded' : ''}`}>
					{!expanded ? (
						<MdVerticalAlignTop
							size={30}
							className="menu-expand"
							title="Comprimir"
							cursor={'pointer'}
							onClick={() => setExpanded(!expanded)}
						/>
					) : (
						<MdVerticalAlignBottom
							size={30}
							className="menu-expand"
							title="Expandir"
							cursor={'pointer'}
							onClick={() => setExpanded(!expanded)}
						/>
					)}

					<span className="title">Status B2C</span>
				</div>

				{!awsState && <span className="message centered">Houve um erro ao realizar a busca de cloudfronts na AWS.</span>}

				{awsState && (
					<>
						{clients.length > 0 && (
							<>
								<div className="countdown">{countdown}</div>

								{!expanded && (
									<div className={`search-header`}>
										<div className="search">
											<input
												className="pesquisa"
												placeholder="Pesquise pelo nome, pacote ou cloudfront..."
												value={pesquisa}
												type="search"
												onChange={(e) => setPesquisa(e.target.value)}
											/>

											<MdOutlineCloudDownload
												className="refresh"
												title="Sincronizar novamente com a AWS"
												onClick={sync}
											/>

											<div className="refresh-configuration">
												<span>Atualiza a cada</span>

												<input
													value={refreshMinutes}
													type="number"
													min="1"
													max="15"
													step="1"
													onChange={(e) => setRefreshMinutes(e.target.value)}
												/>

												<span>minuto(s)</span>
											</div>
										</div>
									</div>
								)}
							</>
						)}
						{clients.length === 0 && <span className="message centered">Carregando...</span>}

						{clients.length > 0 && (
							<>
								<div className="status-content">
									<span className="offline-info">A data e tempo offline são armazenados localmente no navegador e podem estar incorretas.</span>
									<table>
										<thead>
											<tr>
												<th>Cliente</th>
												<th>Cloudfront</th>
												<th className="column-centered">Status</th>
												<th className="column-centered">Data offline</th>
												<th className="column-centered">Ação</th>
											</tr>
										</thead>

										<tbody>
											{clients.filter(filterClients).map((client) => (
												<tr
													id={`client-${client.domain}`}
													key={`client-${client.domain}`}>
													<td>{client.comment.replaceAll('B2C - ', '')}</td>
													<td className="cloudfront">
														<span>{client.domain}</span>
													</td>

													<td className={`column-centered status ${client.status}`}>
														{client.status == null && <AiOutlineLoading3Quarters className="spin" />}

														{client.status != 'loading' && <div title={client.status}></div>}
													</td>

													<td className="column-centered time-offline">
														{formatDateToBrazilian(client.timeOffline)} - {client.offlineText}
													</td>
													<td className="column-centered copy">
														<MdOutlineContentCopy
															title="Copiar"
															onClick={() => {
																navigator.clipboard.writeText(client.domain);
																toast.success('Copiado para a área de transferência!');
															}}
														/>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</>
						)}
					</>
				)}
			</div>
		</PageDefault>
	);
}

export default Status;
